module.exports = __webpack_public_path__ + "img/pc_empty_state.af182cd9.svg";